import { Component } from "react"

/* Modal */
import Modal from "react-modal"

/* Components */
import { Icon } from "../../components"

/* Icons */
import { LoadingOutlined } from "@ant-design/icons"

/* REST API */
import { status } from "../../api/Booking"

/* Helpers */
import { utils } from "../../helpers"

/* Widgets */
import { toast } from "../common"

Modal.setAppElement("#root")


/* Widget Complete Modal — the visit is closed with the amount which was really charged.
   The amount is not obligatory: a visit closed without it keeps the one it was planned with.
   It is opened by the reference: this._complete.current.open(booking) */
class CompleteModal extends Component {

    constructor() {
        super()

        this.state = {
            visible: false,
            saving: false,

            id: 0,
            planned: 0,
            price: "",
            notify: true
        }
    }

    /* Open the form on the amount the visit was planned with */
    open = booking => {

        const planned = parseInt(booking.total) ? parseInt(booking.total) : 0

        this.setState({ visible: true, saving: false, id: booking.id, planned, price: `${planned}`, notify: true })
    }

    /* Close the form */
    close = () => {

        /* The request is already on its way */
        if (this.state.saving) {
            return
        }

        this.setState({ visible: false })
    }

    /* Close the visit */
    save = () => {

        /* Fields */
        const { saving, id, price, notify } = this.state
        const { onSaved } = this.props

        /* The request is already on its way */
        if (saving) {
            return
        }

        this.setState({ saving: true })

        status({ id, action: "complete", finalPrice: price.length > 0 ? parseInt(price) : null, notify }).then(response => {

            if (response && response.status === 200) {

                this.setState({ visible: false, saving: false })

                toast.success("Запись завершена")

                if (onSaved) {
                    onSaved()
                }
            }
            else {
                this.setState({ saving: false })
                toast.error("Не удалось завершить запись")
            }
        }).catch(() => {
            this.setState({ saving: false })
            toast.error("Не удалось завершить запись")
        })
    }

    render = () => {

        /* Fields */
        const { visible, saving, planned, price, notify } = this.state

        return (
            <Modal
                isOpen={visible}
                onRequestClose={this.close}
                className="booking-form-modal small"
                overlayClassName="booking-form-overlay"
                closeTimeoutMS={200}
            >

                <div className="booking-form-header">
                    <h2>Завершить запись</h2>
                    <div onClick={this.close} className="booking-form-close">
                        <Icon name="close" size={11} width={2.2} />
                    </div>
                </div>

                <div className="booking-form-body">

                    <div className="booking-form-hint">По прайсу — {utils.convertor(planned, "₸", 1)}. Если клиент заплатил другую сумму, укажите её.</div>

                    <div className="booking-form-label">Фактическая сумма, ₸</div>

                    <input
                        className="booking-form-input"
                        placeholder="Сумма"
                        value={price}
                        onChange={event => this.setState({ price: event.target.value.replace(/\D/g, "") })}
                    />

                    <div onClick={() => this.setState({ notify: !notify })} className={`booking-form-check ${notify ? "active" : ""}`}>
                        <i />
                        <span>Сообщить клиенту о завершении</span>
                    </div>

                </div>

                <div className="booking-form-footer">
                    <div onClick={this.close} className="booking-form-button light">Отмена</div>
                    <div onClick={this.save} className={`booking-form-button ${saving ? "disabled" : ""}`}>
                        {saving ? <LoadingOutlined /> : "Завершить"}
                    </div>
                </div>

            </Modal>
        )
    }
}

export default CompleteModal
